<script>
import baseMixin from '@/mixins/baseMixin'
import formMixin from '@/mixins/formMixin'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import { filterDuplicateAdminNodes } from '@/helpers/org-tree-helpers'
import TruncatedChipList from '../truncated-chip-list.vue'

export default {
  name: 'SavePresetForm',
  components: { TruncatedChipList },
  mixins: [baseMixin, formMixin],
  model: {
    prop: 'preset',
    event: 'change',
  },
  props: {
    preset: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      isPresetFormValid: false,
      formData: {
        key: '',
        title: '',
        favourite: false,
        selection: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      getPresetByKey: 'orgTree/getPresetByKey',
    }),
    isEditingPreset() {
      if (!this.formData || !this.formData?.key) return false
      return !!this.getPresetByKey(this.formData.key)
    },
    compHeader() {
      if (this.isEditingPreset)
        return {
          title: this.$t('general.orgFilter.dialog.savePreset.editTitle'),
          description: this.$t(
            'general.orgFilter.dialog.savePreset.editDescription',
            [this.formData.key]
          ),
        }

      return {
        title: this.$t('general.orgFilter.dialog.savePreset.title'),
        description: this.$t('general.orgFilter.dialog.savePreset.description'),
      }
    },
    filteredCurrentlySelectedList() {
      return filterDuplicateAdminNodes(this.formData.selection)
    },
    searchableSelection() {
      const trimmedSearchTerm = this.search?.toLowerCase()?.trim() || ''

      if (!trimmedSearchTerm) return this.filteredCurrentlySelectedList

      return this.filteredCurrentlySelectedList.filter((selection) =>
        selection.title.toLowerCase().trim().includes(trimmedSearchTerm)
      )
    },
  },
  mounted() {
    this.formData = cloneDeep(this.preset)
  },
  methods: {
    updateForm() {
      this.$emit('change', this.formData)
    },
    closePresetChip(selection) {
      this.formData.selection = this.formData.selection.filter(
        (selectedItem) => selectedItem.id !== selection.id
      )

      this.updateForm()
    },
  },
}
</script>

<template>
  <div>
    <header>
      <h6 class="text-subtitle-1 font-weight-medium">{{ compHeader.title }}</h6>
      <p class="text-caption opacity-6">{{ compHeader.description }}</p>
    </header>
    <v-form
      v-model="isPresetFormValid"
      lazy-validation
      class="mt-4"
      @input="$emit('validate', isPresetFormValid)"
    >
      <v-text-field
        v-model="formData.title"
        :label="$t('forms.labels.name')"
        required
        :rules="[rules.required]"
        @input="updateForm"
      />
      <v-checkbox
        v-model="formData.favourite"
        class="mt-0 w-fit-content"
        dense
        :label="$t('general.orgFilter.dialog.savePreset.favouriteLabel')"
        @change="updateForm"
      ></v-checkbox>

      <p>Selection ({{ filteredCurrentlySelectedList.length }})</p>

      <TruncatedChipList
        :limit="4"
        :items="searchableSelection"
        closeable
        expandable
        @closeChip="closePresetChip"
      />
    </v-form>
  </div>
</template>
